import React from 'react';

import {
  ReferenceManyField,
  useGetList,
  useRecordContext,
  usePermissions,
  useRedirect,
} from 'react-admin';

import { Button } from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';

import RuleDatagrid from './components/RuleDatagrid';

import { expandedDatagridStyles } from '../../constants/style/datagridStyles';
import { RuleTypes } from '../../constants/ruleTypes';
import { Rule } from '../../utilities/schemas/rules';

import hasAccess from '../../utilities/hasAccess';
import ruleViews from '../../constants/ruleView';
import actions, { Actions } from '../../constants/actions';
import { usePendingReviewBlocked } from '../../context/PendingReviewContext';

export const GetList = (
  triggeredBy: string,
  ruleType: RuleTypes,
  version?: string,
  isDraft?: boolean,
) => {
  const { total } = useGetList('rules', { filter: { ruleType, triggeredBy, ...isDraft ? {} : { version } } });
  if (!total || total === 0) return false;
  return true;
};

export const OpenIconButton = ({
  isDraft,
  ruleType,
  version,
}: {
  isDraft: boolean;
  ruleType: RuleTypes;
  version: string;
}) => {
  const { permissions } = usePermissions<Actions[]>();
  const redirect = useRedirect();
  const rule = useRecordContext<Rule>();
  const isPendingReviewBlocked = usePendingReviewBlocked();

  if (!isDraft && hasAccess(permissions, actions.RULE_GET)) {
    return (
      <Button
        color="secondary"
        startIcon={<VisibilityIcon />}
        onClick={() => redirect(
          'edit',
          `rules/${rule?.id}`,
          'summary',
          undefined,
          {
            record: {
              ruleType,
              view: ruleViews.LIST,
              version,
            },
          },
        )}
      >
        Show
      </Button>
    );
  }

  if (isDraft && hasAccess(permissions, actions.RULE_UPDATE)) {
    return (
      <Button
        startIcon={isPendingReviewBlocked ? <VisibilityIcon /> : <EditIcon />}
        color="secondary"
        onClick={() => redirect(
          'edit',
          `rules/${rule?.id}`,
          'summary',
          undefined,
          {
            record: {
              ruleType,
              view: ruleViews.LIST,
              version,
            },
          },
        )}
      >
        {isPendingReviewBlocked ? 'View' : 'Edit'}
      </Button>
    );
  }

  return null;
};

const RuleExpand = ({
  ruleType,
  version,
  isDraft,
}: {
  ruleType: RuleTypes;
  version: string;
  isDraft: boolean;
}) => (
  <ReferenceManyField
    filter={{ version: isDraft ? null : version }}
    reference="rules"
    source="id"
    target="triggeredBy"
  >
    <RuleDatagrid
      expand={<RuleExpand ruleType={ruleType} version={version} isDraft={isDraft} />}
      isRowExpandable={(row) => GetList(row.id, row.ruleType, version, isDraft)}
      sx={expandedDatagridStyles}
      ruleType={ruleType}
    >
      <OpenIconButton isDraft={isDraft} version={version} ruleType={ruleType} />
    </RuleDatagrid>
  </ReferenceManyField>

);

export default RuleExpand;
